
<template>
  <div :class="classes" :disabled="disableStatus">
    <input v-model="currentVal" :disabled="disableStatus" type="text" class="input input-number__input" @focus="_focus" @blur="_blur"/>
    <button :disabled="disabled_minus" :class="[disabled_minus ? 'btn-secondary' : '']" type="button"
            class="input-number__control input-number--decrease" @click="_minus"></button>
    <button :disabled="disabled_plus" :class="[disabled_plus ? 'btn-secondary' : '']" type="button"
            class="input-number__control input-number--increase" @click="_plus"></button>
  </div>
</template>
<script>
function changeNum (num, step) {
  let numDecimalDigits, stepDecimalDigits, m
  try {
    numDecimalDigits = num.toString().split('.')[1].length
  } catch (e) {
    numDecimalDigits = 0
  }
  try {
    stepDecimalDigits = step.toString().split('.')[1].length
  } catch (e) {
    stepDecimalDigits = 0
  }
  m = Math.pow(10, Math.max(numDecimalDigits, stepDecimalDigits))
  return (Math.round(num * m) + Math.round(step * m)) / m
}

export default {
  name: 'TNumberstepper',
  props: {
    // 初始默认值
    value: {
      type: Number,
      default: 0
    },
    // 初始默认值
    current: {
      type: Number,
      default: 0
    },
    // 最大值
    max: {
      type: Number,
      default: Infinity
    },
    // 最小值
    min: {
      type: Number,
      default: -Infinity
    },
    // 步数值
    step: {
      type: Number,
      default: 1,
      validator: value => value >= 0
    },
    // 是否禁止点击
    disabled: {
      type: Boolean,
      default: false
    },
    // 组件的大小=>''、sm、lg
    size: {
      type: String,
      default: '',
      validator (value) {
        return [ '', 'sm', 'lg' ].indexOf(value) > -1
      }
    }
  },
  data () {
    return {
      currentVal: this.value || this.current,
      oldVal: '',
      disabled_minus: false,
      disabled_plus: false,
      disableStatus: this.disabled
    }
  },
  computed: {
    // size的值为''、sm、lg时所对应的样式不同
    classes () {
      return [ 'form-input-number', this.size ? `form-input-number--${this.size}` : '' ]
    }
  },
  watch: {
    value (newVal) {
      this.currentVal = newVal
    },
    currentVal (newVal, oldVal) {
      if (isNaN(newVal)) {
        this.currentVal = oldVal
      }
      this._checkStatus(newVal)
    },
    min () {
      this._checkValid(this.currentVal)
    },
    max () {
      this._checkValid(this.currentVal)
    },
    disabled (newVal) {
      this.disableStatus = newVal
    }
  },
  created () {
    this._checkValid()
    this._checkStatus(this.currentVal)
  },
  methods: {
    // 当输入框失去焦点的时候触发
    _blur (e) {
      let inputVal = Number(e.target.value)
      if (isNaN(inputVal)) {
        inputVal = this.value
      }
      this._setValue(inputVal, true)
    },
    _focus(e) {
      this.oldVal = this.currentVal
    },
    _checkValid (val) {
      this.disableStatus = this.disabled || (val < this.min || val > this.max)
    },
    _checkStatus (val) {
      this.disabled_minus = false
      this.disabled_plus = false
      if (val <= this.min) {
        this.disabled_minus = true
      } else if (val >= this.max) {
        this.disabled_plus = true
      }
    },
    toggle (value) {
      this.disableStatus = !this.disableStatus
    },
    _setValue (nextValue, inputEvent = false) {
      let oldValue = inputEvent ? this.oldVal : this.currentVal
      nextValue = Number.parseFloat(nextValue)
      if (nextValue < this.min) {
        this.currentVal = this.min
      } else if (nextValue > this.max) {
        this.currentVal = this.max
      } else {
        this.currentVal = nextValue
      }
      this.$emit('input', this.currentVal)
      this.$emit('on-change', this.currentVal, oldValue)
    },
    _plus () {
      if (this.disabled) return
      this._setValue(changeNum(this.currentVal, this.step))
    },
    _minus () {
      if (this.disabled) return
      this._setValue(changeNum(this.currentVal, -this.step))
    }
  }
}
</script>



// WEBPACK FOOTER //
// numberstepper.vue?66f7c29c